interface EmptyStateProps {
  title: string;
  desc: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, desc, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-500">
        <i className="ri-emotion-sad-line text-2xl"></i>
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600">{desc}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}